/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import { RadioButton, RadioGroup } from '@americanexpress/dls-react';
import { TooltipPlacement } from 'src/types/tooltip-placement.enum';
import LiteralsService from '../../services/literals/LiteralsService';
import { MonteCarloViewModel } from 'src/types/view-models/monte-carlo.view.model';
import { MonteCarloEstimate } from 'src/types/monte-carlo.enum';
import MoreInfoTooltip from '../more-info-tooltip/MoreInfoTooltip';
import { HELP_DOMAIN } from 'src/utils/constants';

// styles
import styles from './MonteCarlo.module.scss';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Selectors from 'src/utils/selectors';

export default class MonteCarlo extends Component<MonteCarloViewModel> {
    public override render(): ReactComponentElement<any> {
        const projectionUrl: string = HELP_DOMAIN ? HELP_DOMAIN + '/articles/projections' : null;
        return (
            <div className={styles.monteCarloDiv} data-cy={Selectors.PlanAhead.MONTE_CARLO}>
                <div className={styles.monteCarloHeader}>
                    <Typography variant={TypographyVariants.HEADING_XS} className="adjust textDefault" key="adjust">
                        Adjust projection probabilities
                    </Typography>
                    <MoreInfoTooltip
                        title={LiteralsService.getLiteral('AssetDebtDrawer.tooltipTitle')}
                        body={LiteralsService.getLiteral('AssetDebtDrawer.projection')}
                        linkName={LiteralsService.getLiteral('AssetDebtDrawer.joinDiscussion')}
                        link={projectionUrl}
                        placement={TooltipPlacement.BOTTOM}
                        buttonAriaLabel={LiteralsService.getLiteral('AssetDebtDrawer.tooltipTitle')}
                    />
                </div>
                <RadioGroup
                    className={styles.radioButtons}
                    defaultChecked={this.props.monteCarlo}
                    onChange={this.props.handleClick}
                >
                    <RadioButton id="monte-pessimistic" value={MonteCarloEstimate.PESSIMISTIC} label="Pessimistic" />
                    <RadioButton id="monte-average" value={MonteCarloEstimate.AVERAGE} label="Average" />
                    <RadioButton id="monte-optimistic" value={MonteCarloEstimate.OPTIMISTIC} label="Optimistic" />
                </RadioGroup>
            </div>
        );
    }
}
